import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { AddItem } from './AddItem';
import { Item } from './Item';

@withRouter
export class MembersList extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
    }
    
    render() {
        const { forum, editUser, ...props } = this.props;
        let sortedMembers = forum.members.sort((a, b) => {
            if(a.memberTypeId > b.memberTypeId){
                return 1;
            } else if (a.memberTypeId < b.memberTypeId) {
                return -1;
            } else {
                return 0;
            }
        });
        let users = forum ? sortedMembers.map((item, index) => { return <Item key={"user" + index} editUser={editUser}  {...item}></Item>; }) : undefined;

        return (<div className="col-12 col-md-9">
            <AddItem  user={forum.editingUser} {...this.props} />
            <div className="discussion-board-resource">
                <div className="row">
                    <div className="col-1 col-lg-1">
                        <strong></strong>
                    </div>
                    <div className="col-10 col-lg-4">
                        <strong>EMAIL</strong>
                    </div>
                    <div className="col-4 col-lg-4">
                        <strong>NAME</strong>
                    </div>
                    <div className="col-3 col-lg-2">
                        <strong>LAST ACTIVITY</strong>
                    </div>
                    <div className="col-1 col-lg-1">
                    </div>
                </div>
                {users}
            </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Member/List.tsx